// The export routes return a short-lived, presigned S3 URL with the download
// filename already baked into its Content-Disposition header, so a plain
// anchor click is enough — no blob/fetch handling needed on this side.
export function triggerBrowserDownload(url) {
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
